import { Navbar, NavbarItem, NavbarSection } from './Navbar'

export const Tabs = ({ className, children }: { className?: string; children: React.ReactNode }) => {
  return (
    <Navbar className={className}>
      <NavbarSection className="w-full flex">{children}</NavbarSection>
    </Navbar>
  )
}

type TabItemProps = {
  children: React.ReactNode
  current: boolean
  to?: string
  icon?: React.ReactNode
  onClick?: () => void
}

export const TabItem = ({ children, current, to, icon, onClick }: TabItemProps) => {
  return (
    <NavbarItem
      to={to}
      current={current}
      className="w-fit"
      onClick={onClick}
    >
      {icon && <span data-slot="icon">{icon}</span>}
      {children}
    </NavbarItem>
  )
}

// Simple content wrapper for tab content
export const TabContent = ({ children, isActive }: { children: React.ReactNode; isActive: boolean }) => {
  if (!isActive) return null
  return <div className="mt-4">{children}</div>
}

export default Tabs
